import { __assign, __read } from "tslib";
import React, { useState, useEffect, useCallback, useRef } from 'react';
import classNames from 'classnames';
import { useDefaultValue } from '@tencent/tea-component/lib/form/controlled';
import { SegmentMultiple, Bubble } from '@tencent/tea-component/lib';
import { Badge } from '@tencent/tea-component/lib/badge';
import i18n from '../i18n';
var t = i18n.t;
export function BuySegmentMulti(props) {
    // null 表示不需要有按钮，true 表示收起状态，false 表示展开状态
    var _a = __read(useState(null), 2), moreButtonVisible = _a[0], setMoreButtonVisible = _a[1];
    var _b = useDefaultValue(props, ['']), _c = _b.value, value = _c === void 0 ? [] : _c, onChange = _b.onChange, max = _b.max, _d = _b.disabled, disabled = _d === void 0 ? false : _d, options = _b.options, _e = _b.isTimeSpan, isTimeSpan = _e === void 0 ? false : _e, _f = _b.isShowMore, isShowMore = _f === void 0 ? false : _f, _g = _b.className, className = _g === void 0 ? '' : _g, _h = _b.onShowMoreClick, onShowMoreClick = _h === void 0 ? function () { } : _h;
    var hasBadge = options.some(function (_a) {
        var badge = _a.badge;
        return typeof badge !== 'undefined';
    });
    useEffect(function () {
        var isAllDefaultShow = props.options.every(function (_a) {
            var _b = _a.defaultShow, defaultShow = _b === void 0 ? true : _b;
            return defaultShow;
        });
        // 若全部都需要默认展示，则不需要有展开按钮
        if (isAllDefaultShow) {
            setMoreButtonVisible(null);
        }
        else {
            // 若至少有一个是默认收起，则需要展开按钮
            // 若不需要展开
            if (!isShowMore) {
                setMoreButtonVisible(true);
            }
            else {
                setMoreButtonVisible(false);
            }
        }
    }, [isTimeSpan, isShowMore, JSON.stringify(options)]);
    var newOnChange = useCallback(function (value, context) {
        if (!onChange) {
            return;
        }
        // 若点击的是「更多」按钮，则展示更多
        if (value === 'buy-segment-more') {
            onShowMoreClick();
            setMoreButtonVisible(false);
            return;
        }
        // 最大数量限制
        if (max && (value === null || value === void 0 ? void 0 : value.length) > max)
            return;
        onChange(value, context);
    }, [onChange]);
    var newOptions = options;
    // 若要展示更多按钮，则只展示 defaultShow 为 true 的选项
    if (moreButtonVisible === true) {
        newOptions = newOptions.filter(function (_a) {
            var defaultShow = _a.defaultShow;
            return defaultShow;
        });
        newOptions.push({
            value: 'buy-segment-more',
            text: t('更多'),
        });
    }
    newOptions = newOptions.map(function (option) { return (__assign(__assign({}, option), { disabled: disabled || option.disabled, text: React.createElement(Options, { option: option, value: value, disabled: disabled || option.disabled }) })); });
    return (React.createElement(SegmentMultiple, { value: value, onChange: newOnChange, options: newOptions, className: classNames(className + " fix-width buy-segment__multi", {
            'buy-segment-wrap': !isTimeSpan && !hasBadge,
            'buy-segment-discount': options.findIndex(function (_a) {
                var badge = _a.badge;
                return typeof badge !== 'undefined';
            }) !== -1,
            'tea-segment-time-length': isTimeSpan,
            'length-m': isTimeSpan && i18n.language !== 'zh',
        }) }));
}
function Options(props) {
    var contentRef = useRef(null);
    var option = props.option, _a = props.value, value = _a === void 0 ? [] : _a, disabled = props.disabled;
    var _b = __read(useState(false), 2), showBubble = _b[0], setShowBubble = _b[1];
    useEffect(function () {
        var _a, _b;
        if (!contentRef.current)
            return;
        var offsetWidth = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        var scrollWidth = (_b = contentRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth;
        if (scrollWidth > offsetWidth) {
            setShowBubble(true);
            // 在这里执行你想要的操作，例如触发自定义事件。
        }
    }, [option.text]);
    return showBubble ? (React.createElement(Bubble, { content: option.text },
        React.createElement("div", { ref: contentRef, className: "content" },
            option.text,
            option.badge && (React.createElement(Badge, { theme: "warning", dark: value.includes(option.value) || disabled || option.disabled }, option.badge))))) : (React.createElement("div", { ref: contentRef, className: "content" },
        option.text,
        option.badge && (React.createElement(Badge, { theme: "warning", dark: value.includes(option.value) || disabled || option.disabled }, option.badge))));
}
//# sourceMappingURL=BuySegmentMulti.js.map